import InputField from './InputField'

export interface FormFieldsProps {
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void
  fields: Array<InputFieldProps>
  errors?: { [key: string]: string }
}

export interface InputFieldProps {
  label: string
  name: string
  value?: string | number
  type: 'string' | 'number' | 'date' | 'datetime-local'
}
export const FormFields: React.FC<FormFieldsProps> = ({ handleInputChange, fields, errors }) => (
  <>
    {fields.map((field, index) => (
      <InputField
        key={`${index}${field.name}`}
        label={field.label}
        name={field.name}
        value={field.value}
        type={field.type}
        handleInputChange={handleInputChange}
        errors={errors}
      />
    ))}
  </>
)
